import React from "react"
import { FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import AccountManagerUsersTabUsersTable from "./user_tab_details/AccountManagerUsersTabUsersTable"
import AccountManagerUsersTabAddUserDialog from "./user_tab_details/AccountManagerUsersTabAddUserDialog"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IAccountManagerUserDocument, IAddAccountManagerUser } from "../../../models"
import * as api from "../../../api"

interface IProps {
    accountManagerId: string
}

interface IState {
	loading: boolean
	accountManagerUsers: IAccountManagerUserDocument[]
	total: number
	selectedAccountManagerUsers: IAccountManagerUserDocument[]
	searchText: string
	openAddAccountManagerUserDialog: boolean
	editAccountManagerUser: IAccountManagerUserDocument
	offset: number
	limit: number
	limitOptions: number[]
}

export default class AccountManagerDetailsUsersTab extends React.Component<IProps, IState> {
    private AccountManagerUsers: IAccountManagerUserDocument[]
	constructor(props: IProps) {
		super(props)
		this.state = {
			loading: true,
			accountManagerUsers: [],
			total: 0,
			selectedAccountManagerUsers: [],
			searchText: "",
			openAddAccountManagerUserDialog: false,
			editAccountManagerUser: null,
			offset: 0,
			limit: 50,
			limitOptions: [50, 100, 200],
		}
		autobind(this)
	}

	componentDidMount() {
        this.getAccountManagerUsers()
	}

	getAccountManagerUsers() {
        api.getAccountManagerUsers().then(res => {
            this.AccountManagerUsers = res.data as IAccountManagerUserDocument[]
            this.setState({ accountManagerUsers: this.AccountManagerUsers }, () => this.searchAccountManagerUsers())
        })
	}

    searchAccountManagerUsers() {
        const filteredUsers = this.AccountManagerUsers.filter(user => {
			return !this.state.searchText || `${user.FirstName.toLowerCase()} ${user.LastName.toLowerCase()}`.includes(this.state.searchText.toLowerCase()) || user.Email.toLowerCase().includes(this.state.searchText.toLowerCase())
		})
		const accountManagerUsers = filteredUsers ? filteredUsers.filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit) : []
		this.setState({ loading: false, accountManagerUsers, total: filteredUsers.length })
    }


	render() {
		return (
			<div style={{ padding: 30 }}>
				<FloatingActionButton
					className="fixed-add"
					style={{ top: -28, right: 20, zIndex: 500 }}
					secondary
					onTouchTap={() => this.setState({ openAddAccountManagerUserDialog: true, editAccountManagerUser: null })}
				>
					<ContentAdd />
				</FloatingActionButton>
				
                <TableActionBar
                    rowSelectionCount={this.state.selectedAccountManagerUsers.length}
                    singleSelectedMessage={strings.Account_Manager_User_Selected}
                    multipleSelectedMessage={strings.x_Account_Manager_User_Selected}
                    onSearch={searchText => this.setState({ searchText, offset: 0, selectedAccountManagerUsers: [] }, () => this.searchAccountManagerUsers())}
                    searchText={this.state.searchText}
                    searchTextFieldWidth={"92%"}
                    onDeleteClick={() => {
                        if (this.state.selectedAccountManagerUsers[0].Id === AuthenticationStore.getLoggedInAccountManagerUser().Id) {
                            AppStateStore.setProgressSnackbarContent(strings.You_cannot_delete_yourself)
                        }
                        else {
                            AppStateStore.setConfirmDialogContent({
                                title: strings.Delete_Selected_Devices.replace("Devices", "User"),
                                content: strings.Are_you_sure_you_want_to_delete_selected_User,
                                confirm: () => {
                                    AppStateStore.setProgressSnackbarContent("loading")
                                    api.deleteAccountManagerUser(this.state.selectedAccountManagerUsers[0].Id).then(() => {
                                        this.setState({ selectedAccountManagerUsers: [] }, () => {
                                            this.getAccountManagerUsers()
                                            AppStateStore.setProgressSnackbarContent(strings.Account_User_removed_successfully.replace("Account","").trim())
                                        })
                                    })
                                }
                            })
                        }
                    }}
                    title={strings.Account_Manager_Users}
                />
                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    <AccountManagerUsersTabUsersTable
                        users={this.state.accountManagerUsers}
                        selectedUsers={this.state.selectedAccountManagerUsers}
                        onPageClick={offset => this.setState({ offset, selectedAccountManagerUsers: [] }, () => this.searchAccountManagerUsers())}
                        onLimitChange={limit => this.setState({ limit, offset: 0, selectedAccountManagerUsers: [] }, () => this.searchAccountManagerUsers())}
                        offset={this.state.offset}
                        limit={this.state.limit}
                        total={this.state.total}
                        limitOptions={this.state.limitOptions}
                        handleSelectUser={(selectedAccountManagerUsers) => this.setState({ selectedAccountManagerUsers })}
                        handleEditUser={editAccountManagerUser => this.setState({ editAccountManagerUser, openAddAccountManagerUserDialog: true, selectedAccountManagerUsers: [] })}
                    />
                }
				{this.state.openAddAccountManagerUserDialog &&
					<AccountManagerUsersTabAddUserDialog
						editUser={this.state.editAccountManagerUser}
						handleAdd={(user: IAddAccountManagerUser) => {
                            user.AccountManagerId = this.props.accountManagerId
                            this.setState({ openAddAccountManagerUserDialog: false })
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.addAccountManagerUser(user).then(() => {
                                this.getAccountManagerUsers()
                                AppStateStore.setProgressSnackbarContent(strings.User_saved_successfully)
                            }).catch(err => {
                                AppStateStore.setProgressSnackbarContent(err.response.data.message)
                            })
                        }}
						handleUpdate={(user: IAddAccountManagerUser, userId: string) => {
                            user.AccountManagerId = this.props.accountManagerId
                            this.setState({ openAddAccountManagerUserDialog: false })
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.updateAccountManagerUser(user, userId).then((res) => {
                                if (userId === AuthenticationStore.getLoggedInAccountManagerUser().Id) {
                                    const updatedAccountManagerUser = res.data as IAccountManagerUserDocument
                                    AuthenticationStore.updateLoggedInAccountManagerUserData(updatedAccountManagerUser)
                                }
                                this.getAccountManagerUsers()
                                AppStateStore.setProgressSnackbarContent(strings.User_saved_successfully)
                            }).catch(err => {
                                AppStateStore.setProgressSnackbarContent(err.response.data.message)
                            })
		
                        }}
						close={() => this.setState({ openAddAccountManagerUserDialog: false, })}
					/>
				}
			</div>
		)
	}
}
